export default __webpack_public_path__ + "static/l3-49e084489bcf649742a2ad2a57632212.png";